import React from 'react'

import LazyComponent from '../../components/lazy-component'

/**
 * Wrapper for react-dnd DropTarget() HoC, with automatic lazy loading of the react-dnd module
 *
 * @param {node} ChildComponent
 * @param {{{types: string|string[]|function, spec: Object, collect: function}}} options
 */
export default function withDropTarget(ChildComponent, options) {

    return class WithDropTargetWrapper extends LazyComponent {
        constructor(props) {
            super(props)

            this.DropTargetComponent = null

            this.loadModules([
                'react-dnd',
                'react-dnd-html5-backend'
            ])
        }

        initDropTargetComponent() {
            const { DropTarget } = this.modules['react-dnd']
            const { NativeTypes } = this.modules['react-dnd-html5-backend']

            this.DropTargetComponent = DropTarget(
                options.types || NativeTypes.FILE,
                options.spec,
                options.collect
            )(ChildComponent)
        }

        lazyRender() {
            if (!this.DropTargetComponent) {
                this.initDropTargetComponent()
            }

            const RenderComponent = this.DropTargetComponent

            return (
                <RenderComponent {...this.props} />
            )
        }
    }
}


// WEBPACK FOOTER //
// src/containers/high-order-components/with-drop-target.js